export const pageTitle = title => {
  return (document.title =
    title + ' -  National Healthcare & Wellness Mission');
};
